import { Helmet } from 'react-helmet-async';
import { TeamTable } from './components';

export default function TeamPage() {
  return (
    <>
      <Helmet>
        <title> Team </title>
      </Helmet>
      <TeamTable />
    </>
  );
}
